import { render, staticRenderFns } from "./assignments_datatable.vue?vue&type=template&id=7ca93836"
import script from "./assignments_datatable.vue?vue&type=script&lang=js"
export * from "./assignments_datatable.vue?vue&type=script&lang=js"
import style0 from "./assignments_datatable.vue?vue&type=style&index=0&id=7ca93836&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports